export const SearchTypeFileSize = 7 as const;
export type TSearchTypeFileSize = typeof SearchTypeFileSize;

/** elementSubType1 */
export enum FileSizeType {
	APPROXIMATELY = 0,
	GREATER_THAN = 1,
	LESS_THAN = 2,
	EQUAL_TO = 3,
}

/** elementSubType2 */
export enum FileSizeMetric {
	BYTES = 0,
	KBYTES = 1,
	MBYTES = 2,
	GBYTES = 3,
}
